// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateStatus = status => ({
    data: status,
    type: actions.UPDATE_TCSM_SPA_CLAIM_STATUS
});



// WEBPACK FOOTER //
// ./src/tcsm/spa-details/action-creators/update-status.js